export default class EnterpriseLimits {
  public documentSize: number;
  public pagesPerDocument: number;

  constructor(options) {
    this.documentSize = options.documentSize;
    this.pagesPerDocument = options.pagesPerDocument;
  }
}
